import React, { useEffect, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import Paginador, { PaginationProvider } from 'react-bootstrap-table2-paginator'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../conexoes/api'
import '../../../css/painelAdministrativo/pavGit/pavGit.css'
import {
  desabilitarAcoes,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem
} from '../../../redux/actions/index'
import { formatarData } from '../../../utils/formatadorDataTabela'
import PaginacaoTabela from '../../../utils/paginacaoTabela'
import BarraDadosCliente from '../../componentesModais/barraDadosCliente/barraDadosCliente'
import BarraFiltragem from '../../componentesModais/barraFiltragem/barraFiltragem'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
const valorLimite = 50

//! ESSA TELA ESTA INCOMPLETA, E A ROTA DO BACKEND DELA DA ERRO
//! ESSA TELA ESTA INCOMPLETA, E A ROTA DO BACKEND DELA DA ERRO
//! ESSA TELA ESTA INCOMPLETA, E A ROTA DO BACKEND DELA DA ERRO
//! ESSA TELA ESTA INCOMPLETA, E A ROTA DO BACKEND DELA DA ERRO

function PavGit() {
  // SPINNER
  const [spinAtivo, setSpinAtivo] = useState(true)
  //HOOKS TABELA
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)

  //HOOKS VARIÁVEIS

  // const [NomeTag, setNomeTag] = useState('')
  // const [MensagemTag, setMensagemTag] = useState('')
  // const [TargetTag, setTargetTag] = useState('')
  // const [ReleaseTag, setReleaseTag] = useState('')
  // const [CommitTag, setCommitTag] = useState('')
  // const [flAtivo, setFlAtivo] = useState(0)
  // const [isSelect, setIsSelect] = useState(false)
  //HOOKS MENESAGENS
  // const [mensagemErro, setMensagemErro] = useState(
  //   'Ocorreu um erro ao executar esta ação'
  // )
  // const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  //HOOKS MODAL
  // const [revelarCadastro, setRevelarCadastro] = useState(false)
  //HOOKS REDUX
  const despacho = useDispatch()
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)
  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  // let NovoRelease = useSelector(
  //   (state) => state.manejadorState.revelarNovoRelease
  // )

  let itensVar = []
  // USABILIDADE
  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(124) // 'pavGitTabelaGrid'
      setColetaUsabilidade(false)
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) 


  useEffect(() => {
    despacho(revelarBarraFiltragem(false))
    if (!filtros.vazio) {
      despacho(mudarFiltros({ vazio: 'vazio' }))
    }
    despacho(limpadorFiltros(true))
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setSpinAtivo(true)
    despacho(mudarManejador('release'))
    despacho(desabilitarAcoes(false))

    async function carregarTabela() {
      //clicou no botão de limpar a busca geral e retorna tudo ao estado original
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão de busca geral
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão para filtro
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      if (conteudoBusca && filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          await contarItens()
          const { data } = await api_gateway.get('/m1/consultar/git/release')
          inserirData(data.dados)
        }
      } else if (!filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        const dados = {
          paguinaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.post('/m1/filtrar/git', dados)
          inserirData(data.dados)
        }
      } else {
        if (totalPaginas == 0) {
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.get('/m1/consultar/git/release')

          inserirData(data.dados)
        }
      }
      setSpinAtivo(false)
    }
    carregarTabela()
  }, [paginaAtual, conteudoBusca, renderizar, filtros])

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData = []
    if (controladorPagina <= paginaAtual) {
      if (controladorPagina <= paginaAtual && filtros.vazio) {
        apiData = await api_gateway.get('/m1/consultar/git/release')
      } else {
        const dados = {
          paguinaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros,
          contar: true
        }
        apiData = await api_gateway.post('/m1/filtrar/git', dados)
      }
      itensVar = []
      if (apiData.data.dados) {
        totalPaginas = Math.ceil(apiData.data.dados.length / valorLimite)
        totalItens = apiData.data.dados.length
        for (var i = 0; i < apiData.data.dados.length; i++) {
          arrayItens.push(i)
        }
        itensVar = arrayItens
      }
    }
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    setPaginaAtual(1)
  }

  const colunas = [
    {
      dataField: 'name',
      text: 'Nome da Release',
      sort: true,
      headerClasses: 'tabela-coluna-primeira-header nao-selecionavel',
      formatter: (cell) => {
        if (!cell) {
          return <p className="fonte-cor-1 label-tabela-1">-</p>
        } else {
          return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
        }
      }
    },
    {
      dataField: 'tag_name',
      text: 'Nome da Tag',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        if (!cell) {
          return <p className="fonte-cor-1 label-tabela-1">-</p>
        } else {
          return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
        }
      }
    },
    {
      dataField: 'description',
      text: 'Descrição',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        if (!cell) {
          return <p className="fonte-cor-1 label-tabela-1">-</p>
        } else {
          return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
        }
      }
    },
    {
      dataField: 'projeto',
      text: 'Projeto',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        if (!cell) {
          return <p className="fonte-cor-1 label-tabela-1">-</p>
        } else {
          return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
        }
      }
    },
    {
      dataField: 'created_at',
      text: 'Data de criação',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        if (!cell) {
          return <p className="fonte-cor-1 label-tabela-1">-</p>
        } else {
          return (
            <p className="fonte-cor-1 label-tabela-1">{formatarData(cell)}</p>
          )
        }
      }
    },
    {
      dataField: 'assets',
      text: 'Assets',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        if (!cell) {
          return <p className="fonte-cor-1 label-tabela-1">-</p>
        } else {
          return (
            <p className="fonte-cor-1 label-tabela-1">{JSON.stringify(cell)}</p>
          )
        }
      }
    },
    {
      dataField: 'author',
      text: 'Autor',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        if (!cell) {
          return <p className="fonte-cor-1 label-tabela-1">-</p>
        } else {
          return (
            <p className="fonte-cor-1 label-tabela-1">{JSON.stringify(cell)}</p>
          )
        }
      }
    },
    {
      dataField: 'commit',
      text: 'Commit Json',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        if (!cell) {
          return <p className="fonte-cor-1 label-tabela-1">-</p>
        } else {
          return (
            <p className="fonte-cor-1 label-tabela-1">{JSON.stringify(cell)}</p>
          )
        }
      }
    }
  ]

  const selecaoLinhas = {
    mode: 'radio',
    onSelect: (row, isSelect) => {
      // setIsSelect(isSelect)
      if (isSelect) {
        // setNomeTag(row.name)
        // setMensagemTag(row.message)
        // setTargetTag(row.target)
        // setReleaseTag(row.release)
        // setCommitTag(row.commit)
        despacho(desabilitarAcoes(false))
      }
    },
    selectionRenderer: ({ mode }) => {
      return (
        <label className="label-checkbox-cliente-virtueyes fonte-cor-1">
          <input type={mode} id="TAG" name="TAG" />
          <span className="checkbox-cliente-virtueyes radio-button-cor-1" />
        </label>
      )
    }
  }

  // const eventosLinhas = {
  //   onClick: (e, row) => {
  //     setNomeTag(row.name)
  //     setMensagemTag(row.message)
  //     setTargetTag(row.target)
  //     setReleaseTag(row.release)
  //     setCommitTag(row.commit)
  //     setFlAtivo(row.fl_ativo)
  //   }
  // }

  const opcoesPaginacao = {
    page: paginaAtual,
    showTotal: true,
    sizePerPage: valorLimite,
    firstPageTitle: 'Primeira',
    lastPageTitle: 'Última',
    nextPageTitle: 'Proxima',
    prePageTitle: 'Anterior',
    custom: true,
    onPageChange: (page) => {
      setPaginaAtual(page)
    }
  }

  //   function colunaAcoes() {
  //     ColetaClickstream(105) // 'colunaAcoes'
  //     return <p className="acoes">Ações</p>
  //   }

  //   function handleCancelar() {
  //     ColetaClickstream(98) // 'handleCancelar'
  //     setRevelarMensagemAtencao(false)
  //     setRevelarMensagemErro(false)
  //     setRevelarMensagemSucesso(false)
  //     setRevelarCadastro(!revelarCadastro)
  //     revelarNovoRelease(false)
  //   }

  // function handleMensagemErro() {
  //   if (revelarMensagemErro === false) {
  //     setRevelarMensagemErro(true)
  //   } else {
  //     setRevelarMensagemErro(false)

  //   }
  // }

  function handleMensagemSucesso(confirmacao) {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
    }
    if (confirmacao === true) {
      setRenderizar(!renderizar)
    }
  }

  return (
    <>
      <BarraDadosCliente />
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      {/* {NovoRelease === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastroGit
              tituloJanela="Cadastrar"
              setRevelarCadastro={setRevelarCadastro}
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )} */}
      {revelarBarraFiltro === true && <BarraFiltragem />}
      <PaginationProvider pagination={Paginador(opcoesPaginacao)}>
        {({ paginationProps, paginationTableProps }) => (
          <>
            <BootstrapTable
              classes="tabela"
              condensed
              keyField="name"
              data={itens}
              columns={colunas}
              selectRow={selecaoLinhas}
              noDataIndication={!spinAtivo && 'Nenhum item encontrado'}
              {...paginationTableProps}
            />
            <PaginacaoTabela
              setPaginaAtual={setPaginaAtual}
              totalPaginas={totalPaginas}
              totalItens={totalItens}
              valorLimite={valorLimite}
              paginaAtual={paginaAtual}
              page={paginationProps.page}
              onPageChange={paginationProps.onPageChange}
            />
          </>
        )}
      </PaginationProvider>
      <div className="itens-exibidos-tabela fonte-cor-1">
        Mostrando
        <span className="label-tabela-itens-exibidos">{contador + 1}</span>-
        <span className="label-tabela-itens-exibidos">
          {contador + valorLimite <= totalItens
            ? contador + valorLimite
            : totalItens}
        </span>
        de
        <span className="label-tabela-itens-exibidos">{totalItens}</span>
      </div>
      {revelarMensagemSucesso && (
        <MensagemSucesso
          handleMensagemSucesso={handleMensagemSucesso}
          mensagemTitulo="Sucesso"
          mensagemParagrafo1="Usuário deletado."
          mensagemBotao="Continuar"
        />
      )}
      {/* {revelarMensagemErro && (
        <MensagemErro
          handleMensagemErro={handleMensagemErro}
          mensagemTitulo={mensagemErro}
          mensagemParagrafo1="Erro"
          mensagemParagrafo2={mensagemErro}
          mensagemBotao="Retornar"
        />
      )} */}
    </>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}
//React.memo - nao permitir a renderizacao se o state e o props nao mudarem de estado
export default connect(mapStateToProps)(React.memo(PavGit))
